import { http } from "../config.api.js"
// 企业考评相关

export const listResultInform = (pageInfo, params) => { return http.post("/safetyUnitEvaluationsp/selectUnitResultInform/" + pageInfo, params).then(res => res.data); }

export const homeListResultInform = (pageInfo, params) => { return http.get("/homepage/unitResultInform/" + pageInfo, { urlParams: params }).then(res => res.data); }

export const listResultPublic = (pageInfo, params) => { return http.post("/safetyUnitEvaluationsp/selectUnitResultPunlicitykp/" + pageInfo, params).then(res => res.data); }

export const homeListResultPublic = (pageInfo, params) => { return http.get("/homepage/unitResultPunlicity/" + pageInfo, { urlParams: params }).then(res => res.data); }

export const listEvalFill = (pageInfo, params) => { return http.get("/safetyConstructionLicense/unitInfos/" + pageInfo, { urlParams: params }).then(res => res.data); }

export const getUnitBaseInfo = params => { return http.get("/safetyConstructionLicense/getUnitBaseInfo", { urlParams: params }).then(res => res.data); }

export const updateRecord = params => { return http.get("/safetyConstructionLicense", { urlParams: params }).then(res => res.data); };

export const addBaseInfo = params => { return http.post("/safetyConstructionLicense/add", params).then(res => res.data); };

export const evalueSave = params => { return http.post("/safetyUnitEvaluationhz/save", params).then(res => res.data); };

export const evalueSubmit = params => { return http.post("/safetyUnitEvaluationhz/submit", params).then(res => res.data); };

export const selfSubmit = params => { return http.post("/safetyUnitSelfEval/submitUnitsSelfEval", params).then(res => res.data); };

export const sealAndSubmitHz = params => { return http.post("/safetyUnitEvaluationhz/sealAndSubmitHz", params).then(res => res.data); };
export const updateAttachFileInfoHz = params => { return http.post("/safetyUnitSelfEval/updateAttachFileInfoHz", params).then(res => res.data); };
export const sealAndSubmitSq = params => { return http.post("/safetyUnitSelfEval/sealAndSubmitSq", params).then(res => res.data); };
export const updateAttachFileInfoSq = params => { return http.post("/safetyUnitSelfEval/updateAttachFileInfoSq", params).then(res => res.data); };

export const isAllowAdd = params => { return http.get("/safetyUnitEvalRepeat/isAllowAdd",  { urlParams: params }).then(res => res.data); };
export const updateUnitInfo = params => { return http.get("/safetyConstructionLicense/updateUnitInfo",  { urlParams: params }).then(res => res.data); };



// WEBPACK FOOTER //
// ./src/api/safetyCheck/api_cstEnterprise.js